<div class="request-consultation">
    <div class="wrapper flex ai-c jc-sb" responsive-breakpoints>
        <div class="dark title">
           {{'REQUEST_CONSULTATION.HOW_REQUEST' | translate}}  <br>
           {{'REQUEST_CONSULTATION.CONSULTATION' | translate}}
        </div>
        <div class="steps flex">
            <div class="step flex ai-c mapfre-ml-l">
                <div class="index">1</div>
                <div class="mapfre-fs-s text mapfre-ml-m dark">{{'REQUEST_CONSULTATION.CHOOSE' | translate}} <br> {{'REQUEST_CONSULTATION.SPECIALTY' | translate}}</div>
            </div>
            <div class="step flex ai-c mapfre-ml-sl">
                <div class="index">2</div>
                <div class="text mapfre-fs-s mapfre-ml-m dark">
                  {{'REQUEST_CONSULTATION.CHOOSE' | translate}} <br>{{'REQUEST_CONSULTATION.TRAINING' | translate}}
                </div>
            </div>
            <div class="step flex ai-c mapfre-ml-sl">
                <div class="index">3</div>
                <div class="mapfre-fs-s mapfre-ml-m dark text">
                  {{'REQUEST_CONSULTATION.DATE' | translate}}   <br> {{'REQUEST_CONSULTATION.GO_TO_CENTER' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
